// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"66e7b2f4","230":"bdc42398","235":"88543a92","256":"814a1ca0","289":"474e1f8b","355":"0bc7c353","470":"088a1c4a","500":"9c049370","556":"f7098bfb","588":"88490938","644":"ed98483e","807":"9592adf9"}[chunkId] + ".chunk.js";
};